import { createMultiStyleConfigHelpers as c } from "@chakra-ui/react";
import { ThemeColorToken as o, ThemeFontSizeToken as f } from "../theme-tokens.js";
import { inputConfig as e } from "./input-theme.js";
import { selectAnatomy as s } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { defineMultiStyleConfig: u, definePartsStyle: a } = c(s.keys);
var t, n;
const l = a({
  // Apply input theme, as Select and Input share most of their appearances
  ...(t = e.variants) == null ? void 0 : t.outline,
  field: {
    // Apply input theme, as Select and Input share most of their appearances
    ...(n = e.variants) == null ? void 0 : n.outline.field,
    // Give nested option elements color styles to match the select element.
    // Only applicable to Microsoft desktop browsers, will be ignored by browsers that use their own native styles.
    "> option, > optgroup": {
      color: o.OnSurface,
      background: o.Surface
    }
  },
  icon: {
    fontSize: f.Small,
    color: o.OnSurface,
    _disabled: {
      opacity: 1,
      color: o.OnSurfaceSubdued
    }
  }
});
var i, r;
const p = a({
  // Apply input theme, as Select and Input share most of their appearances
  ...(i = e.variants) == null ? void 0 : i.ghost,
  field: {
    // Apply input theme, as Select and Input share most of their appearances
    ...(r = e.variants) == null ? void 0 : r.ghost.field,
    // Give nested option elements color styles to match the select element.
    // Only applicable to Microsoft desktop browsers, will be ignored by browsers that use their own native styles.
    "> option, > optgroup": {
      color: o.OnSurface,
      background: o.Surface
    }
  },
  icon: {
    ...l.icon
  }
}), y = u({
  defaultProps: {
    variant: "outline"
  },
  variants: {
    outline: l,
    ghost: p
  }
});
export {
  y as selectConfig
};
